import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconWellKBKSizeM from './IconWellKBK_size_m';

const props: CreateIconArguments = {
  l: IconWellKBKSizeM,
  m: IconWellKBKSizeM,
  s: IconWellKBKSizeM,
  xs: IconWellKBKSizeM,
  name: 'IconWellKBK',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
